import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Heart, Gem, Truck, Users, ArrowRight } from "lucide-react";
import GoldDivider from "../components/GoldDivider";
import Reveal from "../components/Reveal";

const VALUES = [
  { icon: Gem, title: "Qualité premium", text: "Chaque article est sélectionné pour sa durabilité et son élégance." },
  { icon: Heart, title: "Pensé famille", text: "Des produits utiles qui simplifient le quotidien de toute la famille." },
  { icon: Truck, title: "Livraison soignée", text: "Un service rapide et attentionné partout en Côte d'Ivoire." },
  { icon: Users, title: "Proximité", text: "Un conseiller à votre écoute sur WhatsApp, du choix à la réception." },
];

export default function About() {
  return (
    <div data-testid="about-page">
      <section className="hero-noir py-20 px-4 md:px-8 text-center">
        <span className="text-xs uppercase tracking-[0.3em] text-[#B8860B]">Notre histoire</span>
        <h1 className="font-display text-4xl md:text-6xl text-white mt-3 mb-4">
          L'art du <span className="gold-text">meilleur choix</span>
        </h1>
        <GoldDivider />
      </section>

      <section className="max-w-4xl mx-auto px-4 md:px-8 py-16 text-center">
        <Reveal>
          <p className="text-xl md:text-2xl font-display text-[#0A0A0A] leading-relaxed mb-6">
            MaxiChoix est née d'une conviction simple : les objets du quotidien méritent, eux aussi,
            une touche de raffinement.
          </p>
          <p className="text-neutral-600 leading-relaxed max-w-2xl mx-auto">
            Spécialisée dans les articles pratiques, utiles et tendance pour toute la famille, notre boutique
            réunit le meilleur des accessoires maison, voyage, école et bien-être. Nous croyons au luxe accessible :
            des produits fiables, élégants et abordables, livrés avec le soin d'une maison de mode.
            Basés en Côte d'Ivoire, nous mettons un point d'honneur à offrir une expérience d'achat simple,
            chaleureuse et humaine — notamment via WhatsApp, au plus proche de vous.
          </p>
        </Reveal>
      </section>

      <section className="bg-[#FBF9F4] py-16 px-4 md:px-8">
        <div className="max-w-7xl mx-auto">
          <Reveal>
            <h2 className="font-display text-3xl md:text-4xl text-center text-[#0A0A0A] mb-3">Nos valeurs</h2>
            <GoldDivider className="mb-12" />
          </Reveal>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {VALUES.map((v, i) => (
              <Reveal key={v.title} delay={i * 0.08}>
                <div className="bg-white p-8 text-center h-full border border-neutral-100">
                  <div className="w-14 h-14 mx-auto rounded-full border border-[#B8860B]/30 flex items-center justify-center text-[#B8860B] mb-4">
                    <v.icon size={24} strokeWidth={1.5} />
                  </div>
                  <h3 className="font-display text-xl text-[#0A0A0A] mb-2">{v.title}</h3>
                  <p className="text-sm text-neutral-500 leading-relaxed">{v.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 px-4 md:px-8 text-center">
        <Reveal>
          <h2 className="font-display text-3xl md:text-4xl text-[#0A0A0A] mb-6">Prête à faire le meilleur choix ?</h2>
          <Link to="/boutique" className="btn-gold px-8 py-4 rounded-sm inline-flex">
            Découvrir la boutique <ArrowRight size={18} />
          </Link>
        </Reveal>
      </section>
    </div>
  );
}
